"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeTreasuryInstruction = void 0;
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
const api_1 = require("./api");
const utils_1 = require("./utils");
/**
 * Generate instruction to close treasury.
 * This function loads data from blockchain when not all parameters are provided.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {IncentivesDistributionProgram} args.program - anchor program instance
 * @param param {PublicKey} args.treasuryAccount - treasury account
 * @param param {PublicKey} args.adminAuthority - admin authority [SIGNER] (when not provided loaded from treasuryAccount data)
 * @param param {PublicKey} args.tokenStore - treasury token vault (when not provided loaded from treasuryAccount data)
 * @param param {PublicKey} args.transferTokenTo - vault tokens will be transferred to this token account, when not token account then ATA of the address is calculated (default: ATA from provider wallet address)
 * @param param {PublicKey} args.rentCollector - on closing account the rent is payed back here (default: provider wallet address)
 * @type {Object} return - Return data of generated instruction
 * @return {TransactionInstruction} return.instruction - Instruction to close treasury
 */
async function closeTreasuryInstruction({ program, treasuryAccount, adminAuthority, tokenStore, transferTokenTo = program.provider.publicKey, rentCollector = program.provider.publicKey, }) {
    const tokenAuthority = (0, api_1.treasuryTokenAuthorityAddress)({
        programId: program.programId,
        treasury: treasuryAccount,
    }).address;
    if (!adminAuthority || !tokenStore) {
        const treasuryData = await (0, api_1.treasury)({ program, address: treasuryAccount });
        adminAuthority = adminAuthority || treasuryData.adminAuthority;
        tokenStore = tokenStore || treasuryData.tokenStore;
    }
    transferTokenTo = await (0, utils_1.getTransferToAddress)(program.provider.connection, transferTokenTo, tokenStore);
    const instruction = await program.methods
        .closeTreasury()
        .accountsStrict({
        treasuryAccount,
        adminAuthority,
        tokenAuthority,
        tokenStore,
        transferTokenTo,
        rentCollector,
        tokenProgram: solana_spl_token_modern_1.TOKEN_PROGRAM_ID,
    })
        .instruction();
    return { instruction };
}
exports.closeTreasuryInstruction = closeTreasuryInstruction;
//# sourceMappingURL=closeTreasuryInstruction.js.map